import React, { Component } from 'react'
import { Rate } from 'antd'
import PropTypes from 'prop-types'
import css from './index.scss'

export default class CustomRating extends Component {
  state = {}
  handleChange = (value) => {
    this.props.onChange(value)
  }
  render() {
    return (
      <div>
        <Rate
          disabled={this.props.disabled}
          defaultValue={this.props.defaultValue}
          allowClear={this.props.allowClear}
          value={this.props.value}
          onChange={this.handleChange}
          className={[
            css.stars,
            this.props.mini ? css.starsMini : '',
            this.props.small ? css.starsSmall : '',
            this.props.large ? css.starsLarge : '',
          ].join(' ')}
          style={{
            ...{ fontSize: 16 },
            ...this.props.style,
          }}
          autoFocus={false}
          ref={this.props.ref}
        />
      </div>
    )
  }
}

CustomRating.propTypes = {
  disabled: PropTypes.bool,
  defaultValue: PropTypes.number,
  allowClear: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func,
  style: PropTypes.object,
  ref: PropTypes.func,
  small: PropTypes.bool,
  mini: PropTypes.bool,
  large: PropTypes.bool,
}

CustomRating.defaultProps = {
  disabled: false,
  defaultValue: 0,
  allowClear: false,
  value: 0,
  onChange: () => {},
  style: {},
  ref: () => {},
  small: false,
  mini: false,
  large: false,
}
